import React from "react";
import RouterComponent from "./router/RouterComponent";
import "./App.css";

function App() {
  return (
    <div className="App">
      <RouterComponent />
    </div>
  );
}

export default App;
